module.exports = __webpack_public_path__ + "media/images/career_camp/2023/footer-village-543978d7db3142a207def5c79603418f.png";